import React from 'react';
import { jc, patchUrlByLocale, addSlashToEndOfUrl } from 'utils';
import {
  variantImageLink,
  variantItemWrap,
  variantLink,
  variantItemWrapInactive,
  variantItemWrapActive,
  disabledFromSelect,
  variantDrawerLink,
  variantImageDrawerLink,
  variantItemDrawerWrapInactive,
  variantItemDrawerWrapActive,
} from './variant-item.styles';

export const DATA_QA_VARIANT_ITEM = 'variant-item';

export interface VariantItemDataProps {
  toProductUrl: string;
}

type VariantItemProps = {
  asImageThumb?: boolean;
  inactive?: boolean;
  active?: boolean;
  disabled?: boolean;
  isDrawerVariant?: boolean;
  onSelectVariant?: (url: string) => void;
} & VariantItemDataProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

export const VariantItem = React.forwardRef<HTMLDivElement, VariantItemProps>(
  (
    {
      toProductUrl,
      children,
      className = '',
      asImageThumb,
      inactive,
      active,
      disabled,
      isDrawerVariant = false,
      onSelectVariant,
    },
    ref,
  ) => {
    const slashedToProductURL = addSlashToEndOfUrl(toProductUrl);
    const productUrl = patchUrlByLocale(slashedToProductURL);

    const linkClasses = isDrawerVariant ? [variantDrawerLink] : [variantLink];
    if (asImageThumb) {
      if (isDrawerVariant) {
        linkClasses.push(variantImageDrawerLink);
      } else {
        linkClasses.push(variantImageLink);
      }
    }

    const handleVariantClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (onSelectVariant) {
        event.preventDefault();
        onSelectVariant(productUrl);
      }
    };

    const content = (
      <a className={jc(...linkClasses, 'a-some-link')} href={productUrl} onClick={handleVariantClick}>
        {children}
      </a>
    );

    const itemClasses = [className, variantItemWrap];
    if (disabled) itemClasses.push(disabledFromSelect);
    if (inactive) {
      itemClasses.push(isDrawerVariant ? variantItemDrawerWrapInactive : variantItemWrapInactive);
    }
    if (active) {
      itemClasses.push(isDrawerVariant ? variantItemDrawerWrapActive : variantItemWrapActive);
    }

    return (
      <div data-qa={DATA_QA_VARIANT_ITEM} ref={ref} className={jc(...itemClasses)}>
        {content}
      </div>
    );
  },
);
